import React from "react";
import { ResponsiveLine } from "@nivo/line";

const data = [
    {
        id: "Temperature",
        data: [
            { x: "2024-12-01T00:00:00Z", y: 15 },
            { x: "2024-12-01T22:00:00Z", y: 11 },
            { x: "2024-12-02T00:00:00Z", y: 18 },
            { x: "2024-12-03T00:00:00Z", y: 20 },
            { x: "2024-12-04T00:00:00Z", y: 22 },
            { x: "2024-12-05T00:00:00Z", y: 19 },
        ],
    },
];

const MyResponsiveLineChart = () => (
    <div style={{ height: 400 }}>
        <ResponsiveLine
            data={data}
            margin={{ top: 50, right: 50, bottom: 50, left: 60 }}
            xScale={{
                type: "time",
                format: "%Y-%m-%dT%H:%M:%SZ",
                useUTC: true,
                precision: "minute",
            }}
            xFormat="time:%Y-%m-%d"
            yScale={{ type: "linear", min: "auto", max: "auto", stacked: false }}
            axisBottom={{
                //format: "%b %d",
                format: "%Y-%m-%d %H:%M",
                formatType: "time",
                tickValues: "every 6 hours",
                legend: "Time",
                legendOffset: -12,
                legendPosition: "middle",
                tickRotation: 25,
            }}
            axisLeft={{
                legend: "Temperature (°C)",
                legendOffset: -40,
                legendPosition: "middle",
            }}
            colors={{ scheme: "set1" }}
            pointSize={10}
            pointColor={{ theme: "background" }}
            pointBorderWidth={2}
            pointBorderColor={{ from: "serieColor" }}
            useMesh={true}
        />
    </div>
);

export default MyResponsiveLineChart;
